import {useContext, useEffect, useState} from "react";
import CampGrid from "../Layout/CampGrid";
import {useNavigate, useParams} from "react-router-dom";
import Switch from "@mui/material/Switch";
import {FormControlLabel} from "@mui/material";
import AuthContext from "../Services/AuthContext";
import Main from "../Layout/Main";

function SeasonCamp() {
    const params = useParams();
    const [user] = useContext(AuthContext);
    const [items, setItems] = useState([]);
    const [season, setSeason] = useState({name: ''});
    const [archived, setArchived] = useState(false);
    const [camps, setCamps] = useState([]);
    const navigate = useNavigate();
    useEffect(() => {
        if (user.token === "") {
            navigate("/");
        }
    }, [user.token, navigate]);

    useEffect(() => {
        const abortController = new AbortController();
        async function fetchData() {
            await fetch(`/api/season/${params.id}`, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => {
                    setItems(data.camp);
                    setSeason(data.season);
                })
                .catch(err => {
                    console.log(err)
                })
        }
        fetchData();
        return () => abortController.abort();
    }, [params.id, user.token]);

    useEffect(() => {
        const date = new Date();
        setCamps(items.filter((item) => {
            return archived || new Date(item.end_date) > date
        }));
    }, [items, archived]);
    const actions = <FormControlLabel control={<Switch onChange={() => setArchived(a => !a)} checked={archived} />} label="Archiwalne" />;
    return (
        <Main title={`Wydarzenia Sezonu: ${season.name}`} actions={actions}>
            <CampGrid items={camps} />
        </Main>
    );
}

export default SeasonCamp;